import { render, staticRenderFns } from "./GuestGender.vue?vue&type=template&id=4872f512"
import script from "./GuestGender.vue?vue&type=script&lang=js"
export * from "./GuestGender.vue?vue&type=script&lang=js"
import style0 from "./GuestGender.vue?vue&type=style&index=0&id=4872f512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports